import { render, staticRenderFns } from "./PromoSkeleton.vue?vue&type=template&id=77da3b13&scoped=true&"
import script from "./PromoSkeleton.vue?vue&type=script&lang=js&"
export * from "./PromoSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PromoSkeleton.vue?vue&type=style&index=0&id=77da3b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da3b13",
  null
  
)

export default component.exports